import { render, staticRenderFns } from "./PainelConectores.vue?vue&type=template&id=195aad40&scoped=true&"
import script from "./PainelConectores.vue?vue&type=script&lang=js&"
export * from "./PainelConectores.vue?vue&type=script&lang=js&"
import style0 from "./PainelConectores.vue?vue&type=style&index=0&id=195aad40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195aad40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
